import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { NewSectionInner } from '../../NewSection';

export const HeroContent = styled(NewSectionInner)`
  position: relative;
  z-index: 2;

  ${maxMediaQueries.phone`
    padding-bottom: 15px;
  `};
`;
